/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetUserFavoriteMediaResponse } from '../../models/set-user-favorite-media-response';
import { UserServiceSetUserFavoriteMediaRequest } from '../../models/user-service-set-user-favorite-media-request';

export interface UserServiceSetUserFavoriteMedia$Params {
  userUuid: string;
      body: UserServiceSetUserFavoriteMediaRequest
}

export function userServiceSetUserFavoriteMedia(http: HttpClient, rootUrl: string, params: UserServiceSetUserFavoriteMedia$Params, context?: HttpContext): Observable<StrictHttpResponse<SetUserFavoriteMediaResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceSetUserFavoriteMedia.PATH, 'post');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SetUserFavoriteMediaResponse>;
    })
  );
}

userServiceSetUserFavoriteMedia.PATH = '/api/v3/gateway/user/{userUuid}/favorite/media';
